import { EmploymentPeriodDTO } from 'api/core/models';
import { Actions, MultiInputControls } from 'pages/components/form/MultiInput/MultiInputControls';
import React, { ReactNode } from 'react';
import { getDefaultEmploymentPeriod } from '../../../../Settings/emptyModels';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { LabelledCalendar } from '../../../components/form/LabelledCalendar';
import { InputGroup } from '../layout/InputGroup';
import { Fieldset } from '../layout/Fieldset';

interface Props {
  title: string;
  checkPermission: CheckPermissionFunction;
  employmentPeriods: EmploymentPeriodDTO[];
  onChange: (po: EmploymentPeriodDTO[]) => void;
  validation?: ValidationResult;
  autoFocus: boolean;
}

export const EmploymentPeriods: React.FC<Props> = (props: Props): ReactNode => {
  return (
    <Fieldset title={props.title}>
      <MultiInputControls<EmploymentPeriodDTO>
        canEdit={props.checkPermission().canWrite}
        addNew={(rows: EmploymentPeriodDTO[]): number => rows.push(getDefaultEmploymentPeriod())}
        lines={props.employmentPeriods}
        onChange={props.onChange}
        renderLines={(employmentPeriod: EmploymentPeriodDTO, onLineChange: (ep: EmploymentPeriodDTO) => void, actions: Actions, idx: number): ReactNode => (
          <InputGroup
            delete={{
              action: actions.delete,
              disabled: !props.checkPermission('employment_periods').canWrite,
            }}
          >
            <LabelledCalendar
              id={`employmentPeriod-${idx}-startDate`}
              autoFocus={props.autoFocus}
              value={employmentPeriod.startDate}
              permissions={props.checkPermission('employment_periods.start_date')}
              validation={props.validation?.children[idx]?.fields?.start_date}
              onChange={(startDate: Date): void => onLineChange({...employmentPeriod, startDate})}
              label={`${props.title}.attr.startDate`}

            />
            <LabelledCalendar
              id={`employmentPeriod-${idx}-endDate`}
              value={employmentPeriod.endDate}
              permissions={props.checkPermission('employment_periods.end_date')}
              validation={props.validation?.children[idx]?.fields?.end_date}
              onChange={(endDate: Date): void => onLineChange({...employmentPeriod, endDate})}
              label={`${props.title}.attr.endDate`}
            />
          </InputGroup>
        )}
      />
    </Fieldset>
  );
};
